import { REQUIRED_EMAIL_VALIDATOR } from '@/helpers/formHelpers/validators';
import { object, ObjectSchema } from 'yup';

type CheckEmailValidationSchemaType = {
  email: string;
};

export const checkEmailValidationSchema: ObjectSchema<CheckEmailValidationSchemaType> = object().shape({
  email: REQUIRED_EMAIL_VALIDATOR,
});
